export default {
  id: 35,
  title: 'Target #35 - Ice Cream',
  url: 'https://cssbattle.dev/play/35',
  colors: ['#293462', '#FFF1C1', '#FE5F55', '#A64942'],
  solution:
    '<a a><a b><style>body{background:#293462}a{position:fixed}a[a]{top:50;left:150;background:#FFF1C1;width:100px;height:150px;border-radius:50px 50px 20px 20px}a[b]{bottom:50;left:185;background:linear-gradient(to bottom,#A64942 10px,#FE5F55 10px);width:30px;height:50px;border-radius:0 0 10px 10px}</style>',
}
